<!--
 * @Description: 总览
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-06-28 17:58:46
 -->
<template>
  <div class="productMonitorOverview">
    <div class="left">
      <div class="left-top">
        <LeftTop />
      </div>
      <div class="left-bottom">
        <LeftBottom />
      </div>
    </div>
    <div class="middle">
      <transition name="el-zoom-in-center">
        <div class="ChinaMap" v-if="mapType === 'China'">
          <dv-flyline-chart-enhanced :dev="true" :config="ChinaMapConfig" style="width:100%;height:100%;" />
        </div>
      </transition>
      <transition name="el-zoom-in-center">
        <div class="HenanMap" v-if="mapType === 'Henan'">
          <dv-flyline-chart-enhanced :dev="true" :config="HenanMapConfig" style="width:100%;height:100%;" />
        </div>
      </transition>
      <!-- 全国地图、河南地图切换 -->
      <div class="mapTabs">
          <span
            :class="[`mapItem ${mapActive === index ? 'active' : ''}`]"
            v-for="(item, index) in mapTabs"
            :key="index"
            @click="selectMap(index)">{{item.label}}</span>
        </div>
      <!-- 现有产品数量 -->
      <div class="productStatics">
        <div class="content">
          现有产品数量 <span class="productNow">{{productStatics.total}}</span> &nbsp;&nbsp;&nbsp;已接入 <span class="connectedProduct">{{productStatics.joined}}</span>
        </div>
      </div>
      <!-- 产品使用情况 -->
      <div class="productUseSituction">
        <div class="dateTabs">
          <span
            :class="[`dateItem ${dateActive === index ? 'active' : ''}`]"
            v-for="(item, index) in dateTabs"
            :key="index"
            @click="selectDate(index)">{{item.label}}</span>
        </div>
        <div class="titleHeader">
          <img src="/static/img/layout/arrow-orange.png" alt="">
          <span class="titleName">产品使用情况</span>
        </div>
        <div class="content">
          <div class="item" v-for="(item, index) in progressConfig" :key="index">
            <span class="title">{{item.name}}</span>
            <dv-percent-pond class="progress" :config="item.config" style="width:40%;height:2vh;" />
            <span class="progressValue">{{item.config.value}}%</span>
            <span :class="activeStatusClass(item.config.value)">{{activeStatus(item.config.value)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="right-top">
        <RightTop />
      </div>
      <div class="right-bottom">
        <RightBottom />
      </div>
    </div>
  </div>
</template>

<script>
import LeftTop from './components/leftTop'
import LeftBottom from './components/leftBottom'
import RightTop from './components/rightTop'
import RightBottom from './components/rightBottom'
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'productMonitorOverview',
  components: {
    LeftTop,
    LeftBottom,
    RightTop,
    RightBottom,
  },
  data () {
    return {
      mapType: 'Henan',
      productStatics: {},
      dateActive: 0,
      mapActive: 1,
      mapTabs: [
        {
          label: '全国',
          value: 'China',
        },
        {
          label: '河南',
          value: 'Henan',
        },
      ],
      dateTabs: [
        {
          label: '今日',
          value: 'day',
        },
        {
          label: '本周',
          value: 'week',
        },
        {
          label: '本月',
          value: 'month',
        },
      ],
      HenanMapConfig: {},
      ChinaMapConfig: {},
      progressConfig: [],
      startDate: timestampFormat('YYYY-mm-dd', new Date()),
      endDate: timestampFormat('YYYY-mm-dd', new Date()),
    }
  },
  methods: {
    /**
     * @description                   产品使用情况动态class
     * @param     {Number}            活跃度值
     * @return {string}               class名
     */
    activeStatusClass (value) {
      if (value <= 20) {
        return 'free'
      } else if (value > 20 && value < 60) {
        return 'commonly'
      } else if (value >= 60) {
        return 'normal'
      }
    },
    /**
     * @description                   产品使用情况状态
     * @param     {Number}            活跃度值
     * @return {string}               状态
     */
    activeStatus (value) {
      if (value <= 20) {
        return '闲置'
      } else if (value > 20 && value < 60) {
        return '一般'
      } else if (value >= 60) {
        return '正常'
      }
    },
    /**
     * @description                   地图切换
     * @param     {Number}          当前选择索引
     * @return {undefied}             无返回值
     */
    selectMap (index) {
      if (this.mapActive === index) {
        return
      }
      this.mapActive = index
      if (index === 0) {
        this.mapType = 'China'
      } else if (index === 1) {
        this.mapType = 'Henan'
      }
    },
    /**
     * @description                   日期切换
     * @param     {Number}          当前选择索引
     * @return {undefied}             无返回值
     */
    selectDate (index) {
      this.dateActive = index
      if (index === 0) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date())
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      } else if (index === 1) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date(new Date().getTime() - (new Date().getDay() - 1) * 86400000))
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      } else if (index === 2) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date(new Date().getTime() - (new Date().getDate() - 1) * 86400000))
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      }
      this.getProductUseData()
    },
    /**
     * @description                   获取产品使用情况数据
     * @return {undefied}             无返回值
     */
    getProductUseData () {
      this.$http.get('/rest/screen/home/listProductUsage', {
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then(res => {
          if (res.code === 0) {
            let data = res.data
            data.map(k => {
              k.config = {
                value: k.usage,
                colors: ['#e04516', '#50f2b7'],
                borderWidth: 1,
              }
            })
            this.progressConfig = data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取河南省地图数据
     * @return {undefied}             无返回值
     */
    getHenanMapData () {
      this.$http.get('/rest/screen/project/list', {
        provinceId: '410000',
      })
        .then(res => {
          if (res.code === 0) {
            let points = [
              {
                name: '郑州市',
                coordinate: [0.52, 0.31],
                icon: {
                  src: '/static/img/layout/mapCenterPoint.png',
                  width: 30,
                  height: 30,
                },
                halo: {
                  show: true,
                },
                text: {
                  color: '#00ffee',
                },
              },
            ]
            let lines = []
            res.data.map(item => {
              if (item.cityPosition) {
                points.push({
                  name: item.cityName,
                  coordinate: [parseFloat(item.cityPosition.split(',')[0]), parseFloat(item.cityPosition.split(',')[1])],
                })
                lines.push({
                  radius: 60,
                  width: 2,
                  source: '郑州市',
                  target: item.cityName,
                })
              }
            })
            this.HenanMapConfig = {
              bgImgSrc: '/static/img/layout/map-henan.png',
              points: points,
              lines: lines,
              icon: {
                show: true,
                src: '/static/img/layout/mapPoint.png',
              },
              text: {
                show: true,
              },
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取全国地图数据
     * @return {undefied}             无返回值
     */
    getChinaMapData () {
      this.$http.get('/rest/screen/project/list')
        .then(res => {
          if (res.code === 0) {
            let points = [
              {
                name: '河南省',
                coordinate: [0.65, 0.45],
                icon: {
                  src: '/static/img/layout/mapCenterPoint.png',
                  width: 30,
                  height: 30,
                },
                halo: {
                  show: true,
                },
                text: {
                  color: '#00ffee',
                },
              },
            ]
            let lines = []
            res.data.map(item => {
              if (item.provincePosition) {
                points.push({
                  name: item.provinceName,
                  coordinate: [parseFloat(item.provincePosition.split(',')[0]), parseFloat(item.provincePosition.split(',')[1])],
                })
                lines.push({
                  radius: 60,
                  width: 2,
                  source: '河南省',
                  target: item.provinceName,
                })
              }
            })
            this.ChinaMapConfig = {
              bgImgSrc: '/static/img/layout/map-China.png',
              points: points,
              lines: lines,
              icon: {
                show: true,
                src: '/static/img/layout/mapPoint.png',
              },
              text: {
                show: true,
              },
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取产品数量数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/home/product/summary')
        .then(res => {
          if (res.code === 0) {
            this.productStatics = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getChinaMapData()
    this.getHenanMapData()
    this.getProductUseData()
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .productMonitorOverview {
    width: 90%;
    height: calc(100% - 10vh);
    margin: 0 5%;
    padding: 5vh 0;
    display: flex;
    justify-content: space-between;
    >div {
      display: inline-block;
    }
    .left {
      width: 26%;
      height: 100%;
      .left-top {
        width: 100%;
        height: 45%;
      }
      .left-bottom {
        width: 100%;
        height: 49%;
      }
    }
    .middle {
      width: 44%;
      height: 100%;
      position: relative;
      // display: flex;
      // justify-content: space-around;
      .productStatics {
        position: absolute;
        left: 0;
        top: 0;
        width: 30%;
        aspect-ratio: 71/13;
        background: url('/static/img/layout/overviewProductBg.png');
        background-size: 100% 100%;
        color: #b6b6b6;
        font-size: 1.4vh;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .content {
          .productNow {
            font-size: 2vh;
            font-weight: bold;
            color: #ffe400;
          }
          .connectedProduct {
            font-size: 2vh;
            font-weight: bold;
            color: #15b9b7;
          }
        }
      }
      .HenanMap {
        width: 75%;
        aspect-ratio: 6.43/6.14;
        position: absolute;
        top: 0;
        left: 12.5%;
      }
      .ChinaMap {
        width: 75%;
        aspect-ratio: 7.07/6.92;
        position: absolute;
        top: 0;
        left: 12.5%;
      }
      .mapTabs {
          position: absolute;
          right: 0;
          top: 0.5vh;
          width: 14%;
          height: 3vh;
          border: 1px solid #05dbe3;
          border-radius: 4px;
          .mapItem {
            text-align: center;
            font-size: 1.4vh;
            color: #fff;
            width: 50%;
            height: 100%;
            display: inline-flex;
            align-items: center;
            justify-content: space-around;
            cursor: pointer;
          }
          .active {
            background: #04b8bf;
          }
        }
      .productUseSituction {
        width: 100%;
        height: 27%;
        position: absolute;
        left: 0;
        bottom: 9%;
        .dateTabs {
          position: absolute;
          right: 0;
          top: 0.5vh;
          width: 20%;
          height: 3vh;
          border: 1px solid #05dbe3;
          border-radius: 4px;
          .dateItem {
            text-align: center;
            font-size: 1.4vh;
            color: #fff;
            width: 33.33%;
            height: 100%;
            display: inline-flex;
            align-items: center;
            justify-content: space-around;
            cursor: pointer;
          }
          .active {
            background: #04b8bf;
          }
        }
        .titleHeader {
          width: 100%;
          height: 4vh;
          background: url('/static/img/layout/titleHeaderBg.png');
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          >img {
            height: 100%;
            margin-right: 20px;
          }
          .titleName {
            font-family: SourceHanSansCN-Bold;
            font-size: 1.5vh;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #05dbe3;
          }
        }
        .content {
          width: 100%;
          height: calc(100% - 4vh);
          .item {
            width: 50%;
            height: 33%;
            display: inline-flex;
            justify-content: space-around;
            align-items: center;
            .title {
              display: inline-block;
              width: calc(35% - 10px);
              padding-right: 10px;
              font-size: 1.4vh;
              color: #fff;
              text-align: right;
              vertical-align: middle;
            }
            .progress {
              display: inline-block;
              vertical-align: middle;
            }
            /deep/.dv-percent-pond text {
              display: none !important;
            }
            .progressValue {
              vertical-align: middle;
              font-size: 1.4vh;
              color: #fff;
              width: 10%;
              text-align: center;
            }
            .free {
              vertical-align: middle;
              border: 1px solid #da0000;
              color: #da0000;
              font-size: 18px;
              border-radius: 4px;
              padding: 2px;
            }
            .commonly {
              vertical-align: middle;
              border: 1px solid #ff7123;
              color: #ff7123;
              font-size: 18px;
              border-radius: 4px;
              padding: 2px;
            }
            .normal {
              vertical-align: middle;
              border: 1px solid #00ffee;
              color: #00ffee;
              font-size: 18px;
              border-radius: 4px;
              padding: 2px;
            }
          }
        }
      }
    }
    .right {
      width: 26%;
      height: 100%;
      .right-top {
        width: 100%;
        height: 45%;
      }
      .right-bottom {
        width: 100%;
        height: 46%;
      }
    }
  }
</style>
